<template>
  <div class="tab-block">

    
  </div>
</template>

<script>
export default {
  props: ["tabData", "code", "seccode", "subcode"],
  data() {
    return {
      isActive: false,
      currentCode: this.code,
    };
  },
  watch: {

  },
  created() { },
  methods: {
    //切换栏目
    changeTab(item, tab) {
      this.$emit("changeSecTab", item, tab);
    },

  },
};
</script>

<style lang="scss" scoped>
.tab-block {
    display: flex;
    flex-direction: column;
    width: 100%;

  .tab-header {
    height: 20px;
    line-height: 1.35em;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    background: #087cd6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tab-list {
    display: flex;
    font-size: 18px;
    padding: 0 18px 0 16px;

    .tab-item {
      position: relative;
      flex: 1;
      display: flex;
      justify-content: center;
      border-bottom: 1px dashed #589ae0;
      cursor: pointer;

      .tab-item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 60px;
      }

      .title {
        flex: 1;
        display: -webkit-box;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }

      .tab-item-content {
        color: #000;

        .tab-item-subtitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 51px;
          padding-left: 1em;
        }

        .triangle {
          border-right-color: #000;
        }
      }
    }

    .tab-item:hover {
      .tab-item-title {
        .triangle {
          border-right-color: #087cd6 !important;
        }
      }
    }

    .tab-active {
      .tab-item-title {
        color: #087cd6;

        .triangle {
          border-right-color: #087cd6 !important;
        }
      }

      .tab-item-title::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%; /* 圆圈居中 */
        transform: translateX(-50%); /* 精确居中 */

        width: 12px;
        height: 12px;
        border: 2px solid #589ae0;
        border-radius: 50%; /* 关键：让它变成圆形 */
      }
    }

    .tab-subtitle:hover {
      .title {
        color: #087cd6;
      }

      .triangle {
        border-right-color: #087cd6 !important;
      }
    }

    .subtitle-active {
      .title {
        color: #087cd6;
      }

      .triangle {
        border-right-color: #087cd6 !important;
      }
    }

    .triangle-active {
      transform: rotate(270deg) !important;
    }
  }
}

</style>
